module.exports = {
  "/": {
    "name": "index",
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  },
  "/forms": {
    "success": {
      "index page loaded": [
        "FORMS_LINK_LOADED"
      ]
    }
  },
  "/live-chat": {
    "success": {
      "index page loaded": [
        "LIVE_CHAT_LINK_LOADED"
      ]
    }
  },
  "/meetings": {
    "success": {
      "index page loaded": [
        "MEETINGS_LINK_LOADED"
      ]
    }
  },
  "/meetings-embedded": {
    "success": {
      "index page loaded": [
        "MEETINGS_LINK_LOADED"
      ]
    }
  }
};